<template>
  <div>
    <h1 id="text_channels"><i class="heart icon"></i> &nbsp;{{$t('Watch Videos You Might Like')}}</h1>
    <div class="ui fluid container">
      <div v-if="loading" class="ui active dimmer">
        <div class="ui text loader">Loading</div>
      </div>
      <ErrorMessage v-if="exception" :message="$t('Something went wrong.', {keySeparator:'#'})" :exception="exception">
      </ErrorMessage>
      <div v-else>
        <div class="ui middle grid">
          <div class="row">
            <div class="ten wide column">
              <div class="ui two column grid" id="listFrame">
                <VideoThumb class="column" v-for="(video, index) in topVideos" :key="video.key"
                  :index="index + 1"
                  :title="video.title"
                  :thumbnail="video.thumbnail"
                  :created="video.created">
                </VideoThumb>
              </div>
            </div>
            <div class="six wide column">
              <div class="ui segment" id="qrcodeFrame">
                <a :href="controllerUrl">
                  <img class="ui fluid image" :src="qrcode">
                  <div class="ui massive info message">
                    {{$t('Scan QR Code to Watch These Videos')}}
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['videos', 'qrcode', 'deviceName', 'controllerUrl', 'loading', 'exception'],
  computed: {
    topVideos () {
      return this.videos && this.videos.slice(0, 4);
    },
  },
}
</script>

<style scoped>

.ui.segment {
  box-shadow: none;
  border: none;
}

.ui[class*="two column"].grid>.thumb {
  width: 47%!important;
  margin: 0 .8vw 2vw;
}

.ui.card:first-child {
  margin-top: 14px;
}
.ui.card:last-child {
  margin-bottom: 14px;
}
.ui.container {
  background-image: radial-gradient(760px at top center,
      rgba(225, 123, 148, 0.65), rgba(225, 123, 148, 0)
    );
}
#listFrame, #qrcodeFrame {
  padding: 2vw 0 0;
  margin: 0 1vw;
  background: none;
}
.ui.grid {
  margin: 0;
}

.ui.massive.info.message {
  background: none;
  color: #ffffff;
  font-family: Helvetica, Arial, sans-serif;
  font-weight: 200;
  font-size: 1.7vw;
  border-radius: 41px;
  border: 2px solid transparent;
  background: #000;
  background-clip: padding-box;
  box-shadow: none;
  padding: 0.4em 1em 0.4em 1em;
  text-align: center;
}
.ui.massive.info.message:before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  margin: -4px;
  /* !importanté */
  border-radius: inherit;
  /* !importanté */
  background: linear-gradient(to right, #e17b94, #684a94);
}
#text_channels {
  margin: 0;
  padding: 0;
  line-height: 7.2vw;
  font-size: 2.8vw;
  padding-left: 2vw;
  color: white;
  font-weight: 100;
  font-family: Helvetica, Arial, sans-serif;
}
#text_channels > .heart {
  color: #e17b94;
}
</style>